import type { TimeFormat } from '@app/api/Branches/types';

import { formatTime } from './appointmentDragUtils';

const HOURS_IN_HALF_DAY = 12;

// Подпись часа на шкале журнала. `formatTime` даёт машинное значение `HH:mm`
// (по нему считают минуты и позиционируют записи) — его формат менять нельзя,
// поэтому 12-часовой вид собирается здесь и только для подписи (issue/11162).
// Часы 0 и 12 показываются как 12, как и в `generateTimes` (moment `hh:mm`),
// которым уже пользуются селекторы времени.
export const formatTimelineLabel = (
  minutes: number,
  timeFormat: TimeFormat | null | undefined
): string => {
  if (timeFormat !== '12-hours') {
    return formatTime(minutes);
  }

  const hours = Math.floor(minutes / 60) % 24;
  const restMinutes = minutes % 60;
  const hours12 = hours % HOURS_IN_HALF_DAY || HOURS_IN_HALF_DAY;

  return `${String(hours12).padStart(2, '0')}:${String(restMinutes).padStart(
    2,
    '0'
  )}`;
};
